<div class="form-group Flexbox">
    <input id="doc" class="admin-ifu ng-pristine ng-untouched ng-valid ng-empty" name="doc"  (change)="upload($event.target.files)" type="file">
    <label class="btnBoarder btn-default primary__button" for="doc">Choose a file</label>
    <input  class="admin-ifu-value Auto_PrivacyNotes ng-pristine ng-untouched ng-valid ng-empty admin-common-doc" [ngModel]="fileName"  disabled="">
</div>

<gen-dynamic-form class="patient-details-wrapper" [formConfig]="inputConfig"
                  [listenToDataChange]="listenToDataChange"
                  [submitted]="widgetFormInstanceSubmitted"
                  [popupMode]="true"
                  (formChange)="formupdate($event.form)"></gen-dynamic-form>
